export const getFilesAsNameAndUrl = (urls) => urls.map((url) => {
  const fileUrl = url;
  const name = url.split('/').pop();
  return { fileUrl, name };
});
